import script from "./employee-block.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-block.vue?vue&type=script&setup=true&lang=js"

import "./employee-block.vue?vue&type=style&index=0&id=2d16387a&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d16387a"]])

export default __exports__